module.exports = __webpack_public_path__ + "img/coin1.cf8dc096.png";